module.exports = __webpack_public_path__ + "img/excel.6191a910.png";